import { SingleTpsLookupResponse } from "../types/services.types";

import { apiGet, apiPost } from "./apiService";

const endpoints = {
  single_tps_lookup: "/tps/single",
  bulk_tps_lookup: "/tps/bulk",
};

export const lookupSingleTps = async (phoneNumber: string): Promise<SingleTpsLookupResponse> => {
  const cleanPhoneNumber = phoneNumber.replace(/\s+/g, "");

  return apiGet<SingleTpsLookupResponse>(
    `${endpoints.single_tps_lookup}/${encodeURIComponent(cleanPhoneNumber)}`,
  );
};

export interface ColumnPair {
  phoneColumn: string;
  tpsColumn: string;
}

export const lookupBulkTps = async (csvFile: File, columnPairs: ColumnPair[]): Promise<Blob> => {
  const metadata: Record<string, string> = {};
  columnPairs.forEach((pair, index) => {
    metadata[`elem_${String(index + 1)}`] = `${pair.phoneColumn},${pair.tpsColumn}`;
  });

  const formData = new FormData();
  formData.append("csv", csvFile);
  formData.append("metadata", JSON.stringify(metadata));

  return apiPost<Blob>(endpoints.bulk_tps_lookup, formData, {
    responseType: "blob",
  });
};
